<form [formGroup]="bookingForm" style="border: 1px solid #e8e8e8;" class="mt-4">
  <div class="col-sm-12 pt-2 pb-2" style="background-color: #efefef;font-size: 19px;font-weight: 600;color: #8f0521;">
    Client Details
  </div>
  <div class="form-group row m-0">
    <div class="col-md-4 mt-4">
      <label class="customLabel"><strong>Flat no.</strong></label>
      <input type="text" class="form-control" formControlName="flat_no" placeholder="">
    </div>
    <div class="col-md-4 mt-4">
      <label class="customLabel"><strong>Floor No.</strong></label>
      <input type="text" class="form-control" formControlName="floor_no" placeholder="">
    </div>
    <div class="col-md-4 mt-4">
      <label class="customLabel"><strong>Building Name</strong></label>
      <input type="text" class="form-control" formControlName="building_name" placeholder="">
    </div>

    <div class="col-md-4 mt-4">
      <label class="customLabel"><strong>Location</strong></label>
      <input type="text" class="form-control" formControlName="location" placeholder="">
    </div>
    <div class="col-md-4 mt-4">
      <label class="customLabel"><strong>City</strong></label>
      <input type="text" class="form-control" formControlName="city" placeholder="">
    </div>
    <div class="col-md-4 mt-4">
      <label class="customLabel"><strong>Pincode</strong></label>
      <input type="text" class="form-control" formControlName="pincode" placeholder="">
    </div>
    <div class="type-data form-check form-check-inline w-100 ml-3 mt-3">
      <label class="customLabel"><strong>Project/Flat Possession:</strong></label>
      <div class="form-group">
        <input type="radio" class="form-check-input ml-3" formControlName="possession_by" value="less_than_90_days">
        <label class="form-check-label pl-5 pr-4">Less than 90 days</label>
      </div>
      <div class="form-group">
        <input type="radio" class="form-check-input ml-3" formControlName="possession_by" value="more_than_90_days">
        <label class="form-check-label pl-5 pr-4">More than 90 days</label>
      </div>
    </div>

    <div class="type-data form-check form-check-inline w-100 ml-3 mt-3">
      <label class="customLabel"><strong>Profession:</strong></label>
      <div class="form-group">
        <input type="radio" class="form-check-input ml-3" formControlName="profession" value="salaried">
        <label class="form-check-label pl-5 pr-4">Salaried</label>
      </div>
      <div class="form-group">
        <input type="radio" class="form-check-input ml-3" formControlName="profession" value="business">
        <label class="form-check-label pl-5 pr-4">Business</label>
      </div>
      <div class="form-group">
        <input type="radio" class="form-check-input ml-3" formControlName="profession" value="other">
        <label class="form-check-label pl-5 pr-4">Other</label>
      </div>
    </div>

    <div class="col-md-4 mt-4">
      <label class="customLabel"><strong>Post/Designation:</strong></label>
      <input type="text" class="form-control" formControlName="designation" placeholder="">
    </div>
    <div class="col-md-4 mt-4">
      <label class="customLabel"><strong>Company's Name:</strong></label>
      <input type="text" class="form-control" formControlName="company" placeholder="">
    </div>

    <div class="type-data form-check form-check-inline w-100 ml-3 mt-3">
      <label class="customLabel"><strong>Professional Details:</strong></label>
      <div class="form-group">
        <input type="radio" class="form-check-input ml-3" formControlName="professional_details" value="it">
        <label class="form-check-label pl-5 pr-4">IT</label>
      </div>
      <div class="form-group">
        <input type="radio" class="form-check-input ml-3" formControlName="professional_details" value="ites/bpo">
        <label class="form-check-label pl-5 pr-4">ITES/BPO</label>
      </div>
      <div class="form-group">
        <input type="radio" class="form-check-input ml-3" formControlName="professional_details" value="doctor">
        <label class="form-check-label pl-5 pr-4">Doctor</label>
      </div>
      <div class="form-group">
        <input type="radio" class="form-check-input ml-3" formControlName="professional_details" value="govt_services/psu">
        <label class="form-check-label pl-5 pr-4">Govt. Services/PSU</label>
      </div>
      <div class="form-group">
        <input type="radio" class="form-check-input ml-3" formControlName="professional_details" value="banking_and_finance">
        <label class="form-check-label pl-5 pr-4">Banking and Finance</label>
      </div>
      <div class="form-group">
        <input type="radio" class="form-check-input ml-3" formControlName="professional_details" value="manufacturing/distribution">
        <label class="form-check-label pl-5 pr-4">Manufacturing/Distribution</label>
      </div>
      <div class="form-group">
        <input type="radio" class="form-check-input ml-3" formControlName="professional_details" value="other">
        <label class="form-check-label pl-5 pr-4">Other</label>
      </div>
      <div class="form-group" *ngIf="bookingForm.value.professional_details == 'other'">
        <label class="customLabel"><strong>Other, Please Specify</strong></label>
        <textarea class="form-control" formControlName="other_professional_details" placeholder=""></textarea>
      </div>
    </div>

    <div class="type-data form-check form-check-inline w-100 ml-3 mt-3">
      <label class="customLabel"><strong>Annual Income (INR - in Lacs):</strong></label>
      <div class="form-group">
        <input type="radio" class="form-check-input ml-3" formControlName="annual_income" value="less_than_15">
        <label class="form-check-label pl-5 pr-4">Less than 15</label>
      </div>
      <div class="form-group">
        <input type="radio" class="form-check-input ml-3" formControlName="annual_income" value="16_25">
        <label class="form-check-label pl-5 pr-4">16-25</label>
      </div>
      <div class="form-group">
        <input type="radio" class="form-check-input ml-3" formControlName="annual_income" value="26_35">
        <label class="form-check-label pl-5 pr-4">26-35</label>
      </div>
      <div class="form-group">
        <input type="radio" class="form-check-input ml-3" formControlName="annual_income" value="36_50">
        <label class="form-check-label pl-5 pr-4">36-50</label>
      </div>
      <div class="form-group">
        <input type="radio" class="form-check-input ml-3" formControlName="annual_income" value="51_and_above">
        <label class="form-check-label pl-5 pr-4">51 and above</label>
      </div>
    </div>

    <div class="col-md-4 mt-4">
      <label class="customLabel"><strong>Landline:</strong></label>
      <input type="text" class="form-control" formControlName="landline" placeholder="">
    </div>
    <div class="col-md-4 mt-4">
      <label class="customLabel"><strong>Mobile(1)</strong></label>
      <input type="text" class="form-control" formControlName="primary_mobile" placeholder="">
    </div>
    <div class="col-md-4 mt-4">
      <label class="customLabel"><strong>Mobile(2)</strong></label>
      <input type="text" class="form-control" formControlName="secondary_mobile" placeholder="">
    </div>

    <div class="col-md-6 mt-4">
      <label class="customLabel"><strong>Email(1)</strong></label>
      <input type="text" class="form-control" formControlName="primary_email" placeholder="">
    </div>
    <div class="col-md-6 mt-4">
      <label class="customLabel"><strong>Email(2)</strong></label>
      <input type="text" class="form-control" formControlName="secondary_email" placeholder="">
    </div>
    <div class="col-md-8 mt-4 mb-3">
      <label class="customLabel"><strong>Current Address:</strong></label>
      <textarea class="form-control" formControlName="current_address"></textarea>
    </div>

  </div>

  <div class="col-sm-12 pt-2 pb-2" style="background-color: #efefef;font-size: 19px;font-weight: 600;color: #8f0521;">
    Order Details
  </div>
  <div class="form-group row m-0">
    <div class="col-md-8 mt-4">
      <label class="customLabel"><strong>Order Value:</strong></label>
      <input type="text" class="form-control" formControlName="order_value" placeholder="">
    </div>
    <div class="col-md-8 mt-4 mb-3">
      <label class="customLabel"><strong>Order Date:</strong></label>
      <input type="date" class="form-control" formControlName="order_date" placeholder="">
    </div>
  </div>
  <button class="btn btn-pink float-right mb-3" value="submit" (click)="bookingFormSubmit()">Submit</button>
</form>


// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/lead/booking-form/booking-form.component.html